export default __webpack_public_path__ + "static/media/N.1c3e5e54.svg";